import { StepSlug, StoreType, type Store } from '@fiverr-private/store_builder_types';

export const STEP_GROUPS = [
    'personalize',
    'connect_to_shopify',
    'complete_setup',
    'prepare_to_sell',
    'publish',
] as const;

export type StepGroups = (typeof STEP_GROUPS)[number];

export type StepCondition = (storeData?: Store) => boolean;

export interface StepConfig {
    slug: StepSlug;
    group: StepGroups;
    condition?: StepCondition;
}

export const STEP_CONFIGS: StepConfig[] = [
    { slug: 'choose-niche', group: 'personalize' },
    { slug: 'choose-banners', group: 'personalize' },
    { slug: 'choose-selling-plan', group: 'personalize' },
    { slug: 'sign-up', group: 'connect_to_shopify' },
    { slug: 'link-your-store', group: 'connect_to_shopify' },
    { slug: 'install-app', group: 'connect_to_shopify' },
    { slug: 'subscribe', group: 'connect_to_shopify' },
    { slug: 'create-store', group: 'complete_setup' },
    { slug: 'additional-services', group: 'prepare_to_sell' },
    {
        slug: 'subscribe-autods',
        group: 'prepare_to_sell',
        condition: (storeData) => storeData?.dropshipper === StoreType.DROPSHIPPER,
    },
    { slug: 'publish', group: 'publish' },
];
